import { Button } from "react-bootstrap"
import FontFa from "../fontFa/fontFa";
import { useState } from "react";

export const CopyButton = (props: {value: string}) => {
    const [isClicked, setIsClicked] = useState(false);
    
    const onHandleCopy = (value: string) => {
        navigator.clipboard.writeText(value);
        setIsClicked(true);
        setTimeout(() => {
            setIsClicked(false)
        }, 1000)
    }

    return <Button onClick={() => onHandleCopy(props.value)} variant="outline" disabled={isClicked} style={{boxShadow: 'none'}}><FontFa name={isClicked ? "faCheck" : "faCopy"} color="#34ebeb" size="sm"/></Button>
}